export const VIDEO_ADDON_CODE = 'video-addon'
export const VIDEO_ADDON_DB_CODE = 'video_addon'
// Policy 8/31/2026: video may be added right up to the event. Inside the
// 15-day window a $450-per-added-talent late booking fee applies instead
// of a hard block (see lib/booking/lateBookingFee.js). 0 = past events only.
export const VIDEO_ADDON_MIN_ADVANCE_DAYS = 0

export const VIDEO_ADDON_PRICING = {
  1: 350,
  2: 600,
  3: 850,
  4: 1100,
  5: 1350,
  6: 1600,
  7: 1850,
  8: 2100
}

export const getVideoAddOnPrice = (hours) => {
  const normalizedHours = Number(hours)
  return VIDEO_ADDON_PRICING[normalizedHours] ?? null
}

export const normalizeVideoAddOnPricing = (priceByHours = {}) => {
  return Object.keys(VIDEO_ADDON_PRICING).reduce((acc, hour) => {
    const fallback = VIDEO_ADDON_PRICING[hour]
    const value = Number(priceByHours?.[hour] ?? priceByHours?.[Number(hour)])

    acc[hour] = Number.isFinite(value) && value > 0 ? value : fallback
    return acc
  }, {})
}

export const getVideoAddOnPriceFromTable = (hours, priceByHours = VIDEO_ADDON_PRICING) => {
  const normalizedHours = Number(hours)
  const normalizedPricing = normalizeVideoAddOnPricing(priceByHours)
  return normalizedPricing[normalizedHours] ?? null
}

export const getVideoAddOnDeliverables = (hours) => {
  const normalizedHours = Number(hours)

  if (normalizedHours === 1) {
    return 'Includes ceremony coverage and delivery of all captured footage, unedited.'
  }

  return 'Includes a professionally edited 1 to 3 minute highlight film.'
}

export const isValidVideoAddOnHours = (hours) => {
  return getVideoAddOnPrice(hours) !== null
}
